import { Link } from "react-router-dom";
import { P } from "const/permissions";
import { usePermission } from "hooks/usePermissions";

export const clientProfilePath = (clientId) => `/admin/client/view/${clientId}`;

/**
 * A referred client's name as a link to their profile. Plain text when the viewer cannot open
 * client profiles or the lead has not converted yet (no client to open). Stops propagation so a
 * table row that opens the lead drawer stays shut when the name itself is clicked.
 */
const ClientProfileLink = ({ clientId, children }) => {
  const canViewClient = usePermission(P.CLIENTS.READ);
  if (!canViewClient || !clientId) {
    return <span className="text-sm">{children}</span>;
  }
  return (
    <Link
      to={clientProfilePath(clientId)}
      onClick={(event) => event.stopPropagation()}
      title="Open client profile"
      className="text-sm font-medium text-teal-700 no-underline hover:underline"
    >
      {children}
    </Link>
  );
};

export default ClientProfileLink;
